/*
 * Module for the mobile user menu control
*/
rs.module("ui/controls/mobileusermenu",

    [],

    function () {

        //
        // Initialize
        //
        function initialize(jsSelectors, cssClasses) {

            var userMenu = $.js(jsSelectors.userMenu);
            var menuToggle = userMenu.js(jsSelectors.menuToggle, { multiple: true });

            // Close user menu when user clicks outside of it
            $(document).click(function (e) {
                if (!userMenu.is(e.target) && !userMenu[0].contains(e.target)) {
                    toggleMenu(false);
                }
            })

            // Show menu when toggle is clicked
            menuToggle.click(function () { toggleMenu(!userMenu.hasClass(cssClasses.open)); });

            // Hide the user menu when a link is clicked
            userMenu.js(jsSelectors.userMenuLink, { multiple: true }).click(function () { toggleMenu(false); });

            //
            // Toggle the visibilty of the menu
            //
            function toggleMenu(open) {
                userMenu.toggleClass(cssClasses.open, open);
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);